import React from 'react';

// Hooks
import { useUpdateAiSetting } from 'Shared/utils/hooks/use-update-ai-setting';
import { useToggle } from 'Shared/utils/hooks';

// Types
import { UpdateAiTemplateSectionType } from 'Shared/types/UpdateAiTemplate.type';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';

// Styles
import './DefaultTemplateSectionListItem.scss';

type Props = {
  updateAiSettingSlug: string;
  section: UpdateAiTemplateSectionType;
};

const DefaultTemplateSectionListItem = ({ updateAiSettingSlug, section }: Props) => {
  const { handleAddSection } = useUpdateAiSetting({
    slug: updateAiSettingSlug,
  });

  const [isAdding, toggleIsAdding] = useToggle(false);

  const handleAddClick = () => {
    toggleIsAdding();
    if (section.slug === 'blank') {
      handleAddSection().then(() => toggleIsAdding());
    } else {
      handleAddSection({
        title: section.title,
        description: section.description,
      }).then(() => toggleIsAdding());
    }
  };

  const baseClassName = 'DefaultTemplateSectionListItem';
  return (
    <WpContainer className={baseClassName} onClick={handleAddClick} role="button">
      <WpContainerBody padding="05">
        <div className={`${baseClassName}__body`}>
          <div className={`${baseClassName}__body__icon`}>
            <WpIcon name={section.iconName} />
          </div>
          <div className={`${baseClassName}__body__text`}>
            <p className={`${baseClassName}__body__text__title`}>{section.title}</p>
            <p className={`${baseClassName}__body__text__description`}>{section.description}</p>
          </div>
          <WpButton variant="tertiary" loading={isAdding}>
            <WpIcon name="plus-circle" />
          </WpButton>
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default DefaultTemplateSectionListItem;
